// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDsfOzU8bvYnBeJu88zUqLT69p5k0weL18",
  authDomain: "habitaly-21f40.firebaseapp.com",
  databaseURL: "https://habitaly-21f40-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "habitaly-21f40",
  storageBucket: "habitaly-21f40.appspot.com",
  messagingSenderId: "1064049265764",
  appId: "1:1064049265764:web:a195b5740d8e8ac4eda371",
  measurementId: "G-JVV56743J5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const database = getDatabase(app);

export {
  app,
  analytics,
  database
};
